import { useAppDispatch, useAppSelector } from "app/hooks";
import { setFilters } from "features/krpano/details-slice";
import { ZFilterPlugin } from "krpano";
import { useEffect } from "react";

type UsePlugins = (krpanoFeaturesReady: boolean) => void;

/**
 * # zFilter Plugin control for krpano
 *
 * @param krpanoFeaturesReady see `AppInner`
 */
export const useZFilterPlugin: UsePlugins = (krpanoFeaturesReady) => {
  const zfilter = useAppSelector((state) => state.krpano.plugins.zfilter);
  const dispatch = useAppDispatch();
  // NOTE: `zfilter` not included in deps so that it only runs once when
  // `krpanoFeaturesReady === true`
  // REASON: We want to sync the Redux State to the krpano plugin only once on
  // load
  useEffect(() => {
    if (krpanoFeaturesReady) {
      const plugin = window.krpano.plugin.getItem<ZFilterPlugin>("zfilter");
      // IDEA: This would require less error checking and may still be responsive
      // for number values ```krpano.tween(`plugin[zfilter].${property}`, value)```
      if (plugin) {
        let updateObject: Parameters<typeof setFilters>[0] = {};
        Object.entries(zfilter).forEach(([key, value]) => {
          if (
            zfilter[key as keyof typeof zfilter] !==
            plugin[key as keyof ZFilterPlugin]
          ) {
            updateObject[key as keyof typeof zfilter] =
              plugin[key as keyof typeof zfilter];
          }
        });
        // IDEA: When plugin is loaded, cobine these results with
        // `parseUrlParams` to set parsed values from URL parameters, this
        // would allow sharing links with custom filter pre-set.
        //
        // Set in Redux state for values that are different to what was originally set there
        dispatch(setFilters(updateObject));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [krpanoFeaturesReady, dispatch]);
};
